module.exports = __webpack_public_path__ + "static/water_optimos3-c2b576588662bb3fd24326ef1a7d1517.jpg";